import {Maybe} from "@/core/types";
import {Element, Product} from "@/gql/gen";
import {CatalogStoreGettersLoader,} from "@/modules/shop/store/util/catalog";

export default function useProduct(
    product: Product,
    gettersLoader: CatalogStoreGettersLoader
): ProductModel {

    const isSaleAllow = () => {
        const price = product.PRICE?.PRICE || 0;
        return !!product.ACTIVE && price > 0 && product.IBLOCK_SECTION_ID !== 94;
    };

    const getSetItems = (withModel = false) => {
        const getters = gettersLoader();
        return product.PROPERTIES.SET_ITEMS.map((item) => {
            const result = {...item} as unknown as ProductSetItem;
            if (item.PRODUCT_ID) {
                result.product = getters.resolveProduct(item.PRODUCT_ID);
                result.productModel = withModel
                    ? getters.resolveProductModel(item.PRODUCT_ID)
                    : null;
            }
            return result;
        });
    };

    const isPriceAvailable = () => {
        return !!(product.PRICE?.PRICE && !product.IS_SALE_SPECIAL);
    };

    const getPriceSource = () => {
        return product.PRICE?.PRICE || 0;
    };

    const getPrice = () => {
        return product.PRICE?.PRICE || 0;
    };

    const getWeight = () => {
        return product.PROPERTIES.WEIGHT || 0;
    };

    return {
        ...product,
        _isModel: true,
        isSaleAllow,
        getSetItems,
        getPriceSource,
        getPrice,
        isPriceAvailable,
        getWeight,
    };
}

export type ProductSetItem = {
    PRODUCT_ID: number;
    QUANTITY: number;
    UID: any;
    PRODUCT_ID_ENTITY: Element | null;
    product: Maybe<Product>;
    productModel: Maybe<ProductModel>;
};

export type ProductModel = Product & {
    _isModel: true;
    isSaleAllow: () => boolean;
    getSetItems: (withModel?: boolean) => ProductSetItem[];
    getPriceSource: () => number;
    getPrice: () => number;
    isPriceAvailable: () => boolean;
    getWeight: () => number;
};
